import {
    getMultiFactorResolver,
    MultiFactorResolver,
    TotpMultiFactorGenerator,
    UserCredential,
} from "firebase/auth";
import { auth } from "../Lib/Firebase";

export function totpResolverFromError(error: any): MultiFactorResolver | null {
    if (error?.code !== "auth/multi-factor-auth-required") return null;
    const resolver = getMultiFactorResolver(auth, error);
    const supportsTotp = resolver.hints.some((hint) => hint.factorId === TotpMultiFactorGenerator.FACTOR_ID);
    if (!supportsTotp) throw new Error("This administrator account does not have a supported authenticator factor.");
    return resolver;
}

export async function resolveTotpSignIn(resolver: MultiFactorResolver, verificationCode: string): Promise<UserCredential> {
    const hint = resolver.hints.find((item) => item.factorId === TotpMultiFactorGenerator.FACTOR_ID);
    if (!hint) throw new Error("No authenticator factor is available for this account.");
    const assertion = TotpMultiFactorGenerator.assertionForSignIn(hint.uid, verificationCode.trim());
    return resolver.resolveSignIn(assertion);
}
